import React from 'react';
import { Box } from '@mui/material';
import { ColumnSelectorOption } from '../../../uikit/itable/ITable';
import ColumnSelector from '../../../uikit/itable/ColumnSelector';
import PaginationBar from '../../PaginationBar';

interface ListBottomBarProps {
  page: number;
  count: number;
  onChange?: (e: React.ChangeEvent<unknown>, value: number) => void;
  availableColumns: ColumnSelectorOption[];
  selectedKeys: string[];
  isDownloadingCsv?: boolean;
  onColumnsChange: (keys: string[]) => void;
  onDownloadCsv?: () => void;
}

const ListBottomBar: React.FC<ListBottomBarProps> = ({ page, count, onChange, availableColumns, selectedKeys, isDownloadingCsv, onColumnsChange, onDownloadCsv }) => {
  const pageCount = Math.max(1, Number(count ?? 1));

  return (
    <Box
      sx={{
        display: 'flex',
        mt: 1,
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {selectedKeys.length > 0 && <PaginationBar page={page} count={pageCount} onChange={onChange} />}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', px: 1 }}>
        <ColumnSelector availableColumns={availableColumns} selectedKeys={selectedKeys} isDownloadingCsv={isDownloadingCsv} onChange={(keys) => onColumnsChange(keys)} onDownloadCsv={onDownloadCsv} />
      </Box>
    </Box>
  );
};

export default ListBottomBar;
